var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page__comsobase-materials"},[_c('SimpleBreadcrumbs',{attrs:{"links":[
      {
        name: 'Головна сторінка',
        href: '/'
      },
      {
        name: 'Навчання',
        href: '/comsobase-materials'
      }
    ]}}),_c('ComsobaseMaterialsActions'),_c('ComsobaseMaterialsInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }